import { AxnCompany } from "@idw-types/data/reference-data/axn";
import { EmailTemplate, FormattedEmailTemplate } from "@idw-types/data/email-template";
import { MultiLanguageWrapper } from "@iddataweb/idw-common-ui/types";
import { TemplateAvailabilityLevelTypes } from "@enums/template-availability-level-types";
import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";

export const formatEmailTemplates = (
    emailTemplates: Array<EmailTemplate>,
    companies: Array<AxnCompany>,
): Array<FormattedEmailTemplate> => {
    return emailTemplates.map(mt => formatEmailTemplate(mt, companies));
};
const getTemplateAvailabilityLevel = (companyId: string): TemplateAvailabilityLevelTypes => {
    if (!companyId) {
        return TemplateAvailabilityLevelTypes.GLOBAL;
    } else {
        return TemplateAvailabilityLevelTypes.ORGANIZATION;
    }
}

export const formatEmailTemplate = (
    emailTemplate: EmailTemplate,
    companies: Array<AxnCompany>,
): FormattedEmailTemplate => {
    const company = companies.find(c => c.id === emailTemplate.organizationID) || null;
    const languages: Partial<MultiLanguageWrapper<{ [key: string]: any }>> = {};
    let parsedLanguages: Partial<MultiLanguageWrapper<string>> = {};
    try {
        parsedLanguages = JSON.parse(emailTemplate.languages);
    } catch (error) {
        console.error("Failed to parse email template languages:", error);
    }
    if (parsedLanguages && Object.keys(parsedLanguages).length > 0) {
        (Object.keys(parsedLanguages) as Array<LocaleTypes>).forEach(locale => {
            try {
                const localeJSON = JSON.parse(parsedLanguages[locale]) || {};
                languages[locale] = localeJSON;
            } catch (error) {
                console.error(`Failed to parse locale JSON for ${locale}:`, error);
            }
        });
    }
    return {
        id: emailTemplate.id,
        name: emailTemplate.name,
        rpServiceID: emailTemplate.rpServiceID,
        status: emailTemplate.status,
        template: emailTemplate.template,
        sender: emailTemplate.sender,
        languages,
        company,
        permissions: emailTemplate.permissions,
        uuid: emailTemplate.uuid,
        templateAvailabilityLevel: getTemplateAvailabilityLevel(emailTemplate.organizationID)
    };
};